import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { IChoosenFilterInterface } from 'app/library/all-users/interfaces/choosen-filter.interface';
import { UserRole } from 'app/library/all-users/models/user-role';
import { AllUsersApiService } from 'app/library/all-users/services/all-users.api-service';
import { UnsubscribeOnDestroy } from 'app/projects/core/src/lib/models/unsubscribe-on-destroy';
import { UserRoleIdEnum } from 'app/projects/shared/src/lib/enums/user-role-id.enum';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-role-filter',
    templateUrl: './role-filter.component.html',
    styleUrls: ['./role-filter.component.scss'],
})
export class RoleFilterComponent extends UnsubscribeOnDestroy implements OnInit {
    @Output()
    addedToList = new EventEmitter<IChoosenFilterInterface[]>();

    @Output()
    choosenRoles = new EventEmitter<UserRole[]>();

    dataSource: UserRole[];
    displayedColumns = ['name', 'buttons'];
    isRoleAddedToList: boolean = false;

    list: IChoosenFilterInterface[] = [];
    userRoles: UserRole[] = [
        {
            id: UserRoleIdEnum.Admin,
            translationKey: 'GENERAL.ADMINISTRATOR',
            selected: false,
        },
        {
            id: UserRoleIdEnum.User,
            translationKey: 'USER.SINGULAR',
            selected: false,
        },
    ];

    constructor(private _allUsersService: AllUsersApiService, private _translateService: TranslateService) {
        super();

        this.dataSource = this.userRoles;
    }

    ngOnInit(): void {
        this._allUsersService.filtersList$.pipe(takeUntil(this._unsubscribeAll)).subscribe((filters) => {
            this.list = filters;
            this.isRoleAddedToList = !!this.list.find((entity) => entity.entity.type === 'UserRole');
            this.updateDataSource();
        });
    }

    updateDataSource(): void {
        this.dataSource = this.userRoles.map((role) => {
            role = Object.assign(new UserRole(), role, {
                selected: this.list.some((item) => item.entity.id === role.id && item.entity.type === 'UserRole'),
            });

            return role;
        });
    }

    addToList(userRole: UserRole): void {
        this.addedToList.emit([
            ...this.list,
            {
                entity: { id: userRole.id, type: 'UserRole' },
                valueToShow: `${this._translateService.instant('GENERAL.PROPERTY.ROLE')}: ${this._translateService.instant(userRole.translationKey)}`,
            },
        ]);
    }

    removeFromList(userRole: UserRole): void {
        this.addedToList.emit(this.list.filter((item) => !(item.entity.id === userRole.id && item.entity.type === 'UserRole')));
    }

    onSelection(): void {
        this.choosenRoles.emit(this.dataSource.filter((role) => role.selected));
    }
}
